/**
 * SessionsToolbar — top action bar for ActiveSessionsPage.
 * Handles: Refresh button, auto-refresh info, client filter, status filter.
 */
import React from 'react';
import { RefreshCw } from 'lucide-react';

const AUTO_REFRESH_MS = 30000;
const fmtShort = (s) => s ? new Date(s).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '—';

export function SessionsToolbar({
  loading, lastFetched, onRefresh,
  clientFilter, clientOptions, onClientChange,
  statusFilter, onStatusChange,
}) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
      <button
        className="erp-btn erp-btn-primary"
        onClick={onRefresh}
        disabled={loading}
        data-testid="sessions-refresh"
        style={{ gap: 6 }}
      >
        <RefreshCw size={12} className={loading ? 'spinning' : ''} /> Refresh now
      </button>
      <span style={{ fontSize: 12, color: 'var(--text-muted, #64748b)' }}>
        Auto-refresh every {AUTO_REFRESH_MS / 1000}s · last fetched {lastFetched ? fmtShort(lastFetched) : '—'}
      </span>

      <div style={{ marginLeft: 'auto', display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
        <label
          htmlFor="sessions-client-filter"
          style={{ fontSize: 12, color: 'var(--text-muted, #64748b)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}
        >
          Client:
        </label>
        <select
          id="sessions-client-filter"
          data-testid="sessions-client-filter"
          value={clientFilter}
          onChange={(e) => onClientChange(e.target.value)}
          style={{
            fontSize: 12, padding: '4px 8px', borderRadius: 6,
            border: '1px solid var(--border, #1e293b)', background: 'var(--surface, #0f172a)',
            color: 'var(--text-primary, #cbd5e1)', minWidth: 220
          }}
        >
          <option value="ALL">All clients ({clientOptions.length})</option>
          {clientOptions.map(o => (
            <option key={o.id} value={o.id}>{o.name} ({o.id})</option>
          ))}
        </select>

        {['ALL', 'ONLINE', 'IDLE', 'OFFLINE'].map(s => (
          <button
            key={s}
            onClick={() => onStatusChange(s)}
            data-testid={`sessions-status-filter-${s}`}
            className={`erp-btn ${statusFilter === s ? 'erp-btn-primary' : ''}`}
            style={{ fontSize: 12, padding: '4px 10px' }}
          >{s}</button>
        ))}
      </div>
    </div>
  );
}
